import React, {useState, useEffect} from 'react'
import {Link} from 'react-router-dom';

/*
* Function for the menu one in redut screen.
* setember 03st, 2025
*/

export function NavShopUp({menuUp, catalogo}) {
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        //console.log(isHovered);
    }, [isHovered]) 

return (
        <>
            {menuUp.map((item) => (
                <div 
                    className="nav-item" 
                    onMouseEnter={() => setIsHovered(true)} 
                    onMouseLeave={() => setIsHovered(false)} 
                    key={item.id}
                >
                    <div className="nav-path" to={item.path}>
                        {item.nome}<div className="arrow-down"></div>
                    </div>
                    
                    {/* Filtra le voci del catalogo in base all'id_categoria */}
                    <div className="dropdown-menu">
                        <div className="dropdown-item">
                            {catalogo
                                .filter(subItem => subItem.id_categoria === item.id)
                                .map(subItem => (
                                    <Link 
                                        to={subItem.collegamento}  // Correggi: era "collegamente"
                                        className="dropdown-link" 
                                        key={`${subItem.id_categoria}-${subItem.nome}`} // Chiave più specifica
                                        state={subItem} // Invece di passare tutto il catalogo, passa solo l'item
                                    >
                                        <i>{subItem.nome}</i> 
                                    </Link>
                                ))}
                        </div>
                    </div>    
                </div>
            ))}
        </>
    );
};


/*
* Function for the menu one in redut screen.
* setember 03st, 2025
*/

export function NavShopDown({menuDown, catalogo}) {
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        //console.log(isHovered);
    },[isHovered]) 

    return (
        <>
            {menuDown.map((item) => (
                <div 
                    className="nav-item" 
                    onMouseEnter={() => setIsHovered(true)} 
                    onMouseLeave={() => setIsHovered(false)} 
                    key={item.id}
                >
                    <div className="nav-path" to={item.path}>
                        {item.nome}<div className="arrow-down"></div>
                    </div>
                    
                    {/* Filtra le voci del catalogo in base all'id_categoria */}
                    <div className="dropdown-menu">
                        <div className="dropdown-item">
                            {catalogo
                                .filter(subItem => subItem.id_categoria === item.id)
                                .map(subItem => (
                                    <Link 
                                        to={subItem.collegamento}  // Correggi: era "collegamente"
                                        className="dropdown-link" 
                                        key={`${subItem.id_categoria}-${subItem.nome}`} // Chiave più specifica
                                        state={subItem} // Invece di passare tutto il catalogo, passa solo l'item
                                    >
                                        <i>{subItem.nome}</i> 
                                    </Link>
                                ))}
                        </div>
                    </div>    
                </div>
            ))}
        </>
    );
};









